import { action, makeObservable, observable } from 'mobx';
import map from 'lodash.map';

export class Message {
  @observable message;
  @observable messageType;

  constructor({ message = '', messageType = '' } = {}) {
    this.message = message;
    this.messageType = messageType;
    makeObservable(this);
  }
}

export class MessageStore {

  constructor() {
    makeObservable(this);
  }

  @observable showMessage = false;
  @observable messages = [];

  @observable showAlert = false;
  @observable alerts = [];

  @action populateMessages() {
    const self = this;
    this.messages = map(this.messages, message => new Message(message));
    if (self.messages.length > 0) {
      self.showMessage = true;
    }
  }

  @action populateAlerts() {
    const self = this;
    this.alerts = map(this.messages, message => new Message(message));
    if (self.alerts.length > 0) {
      self.showAlert = true;
    }
  }

  @action disableMessage() {
    const self = this;
    self.showMessage = false;
  }

  @action setMessages(message, messageType) {
    this.messages = [];
    if (message !== '' && messageType !== '') {
      const messages = [];
      const messageObj = new Message();
      messageObj.message = message;
      messageObj.messageType = messageType;
      messages.push(messageObj);
      this.messages = messages;
    }
  }
}

export default new MessageStore();
